import React, { useEffect, useState } from 'react'
import * as VeiculoHttp from '../../../../services/api/https/registration/veiculo.http'
import { connect } from 'react-redux'
import { errorHandler } from '../../../../services/util/error.service'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import {
  Btn,
  CustomCheckbox,
  CustomDropdown,
  CustomDropdownWithFilter,
  CustomModal,
  CustomRadioButton,
  InputNumeroInteiro,
  InputPlacaVeiculo,
  InputText,
} from '../../../../components'
import { getTransportadoras } from '../../../../services/api/https/registration/transportadora.http'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  INIT: 'Adquirindo informações iniciais',
  BUILD: 'Formatando dados',
  SAVE: 'Salvando veiculo',
  SUCCESS: 'Veiculo salvo com sucesso',
}

const INITIAL_STATE = {
  veiculo: {
    id: undefined,
    manufacturer_id: null,
    default_driver_id: null,
    tp_id: 0,
    nickname: '',
    vehicle_badge: '___-____',
    year: null,
    capacity_kg: null,
    capacity_m3: null,
    tara_kg: null,
    renavam: '',
    uf_licenciamento: '',
    category: 'Proprio',
    initial_km: null,
    qtd_posicoes_carregamento: null,
    max_distance_km: null,
    actived: true,
    tipo_rodado: null,
    tipo_carroceria: null,
  },
  infoIniciais: { manufacturers: [], drivers: [], transportadoras: [] },
  selectedModelo: null,
  selectedMotorista: null,
  selectedTransportadora: null,
  selectedCarroceria: null,
  selectedRodado: null,
  savedVeiculo: {},
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

const CATEGORIES = [
  { label: 'Próprio', value: 'Proprio' },
  { label: 'Terceiro', value: 'Spot' },
]

export const RODADOS = [
  { label: 'Truck (01)', value: '01' },
  { label: 'Toco (02)', value: '02' },
  { label: 'Cavalo Mecânico (03)', value: '03' },
  { label: 'VAN (04)', value: '04' },
  { label: 'Utilitário (05)', value: '05' },
  { label: 'Outros (06)', value: '06' },
]

export const CARROCERIAS = [
  { label: 'Não Aplicável (00)', value: '00' },
  { label: 'Aberta (01)', value: '01' },
  { label: 'Fechada/Baú (02)', value: '02' },
  { label: 'Granelera (03)', value: '03' },
  { label: 'Porta Container (04)', value: '04' },
  { label: 'Sider (05)', value: '05' },
]

const VeiculoModal = ({ show, onModalClose, onModalSave, data, selectedTp, dispatch }) => {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const saveVeiculo = ({
    created_at,
    updated_at,
    manufacturer,
    transportadora_cnpj,
    default_driver_cnh,
    selected,
    ...veiculo
  }) => {
    VeiculoHttp.saveVeiculo(veiculo)
      .then(savedVeiculo =>
        setState(prevState => ({
          ...prevState,
          savedVeiculo: savedVeiculo,
          loadingMessage: LOAD_MESSAGE.SUCCESS,
        })),
      )
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  const getVeiculoInfoIniciais = selectedTp => {
    VeiculoHttp.getVeiculoInfoIniciais(selectedTp)
      .then(infoIniciais => {
        // Remove duplicatas dos motoristas baseando-se no ID
        const uniqueDrivers = Array.from(
          new Map(infoIniciais.drivers.map(driver => [driver.id, driver])).values(),
        )

        // Remove duplicatas dos modelos baseando-se no ID
        const uniqueManufacturers = Array.from(
          new Map(infoIniciais.manufacturers.map(manu => [manu.id, manu])).values(),
        )

        setState(prevState => ({
          ...prevState,
          infoIniciais: {
            ...infoIniciais,
            drivers: uniqueDrivers,
            manufacturers: uniqueManufacturers,
          },
        }))
        getTransportadorasInit(selectedTp)
      })
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  const getTransportadorasInit = async tpId => {
    await getTransportadoras(tpId)
      .then(transportadoras => {
        // Remove duplicatas das transportadoras baseando-se no ID
        const uniqueTransportadoras = Array.from(
          new Map(transportadoras.map(transp => [transp.id, transp])).values(),
        )

        setState(prevState => ({
          ...prevState,
          infoIniciais: { ...prevState.infoIniciais, transportadoras: uniqueTransportadoras },
          loadingMessage: LOAD_MESSAGE.BUILD,
        }))
      })
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  // Events
  const onBtnSalvarClicked = async () => {
    setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE }))
  }

  const onFormContentChange = (name, value) => {
    setState(prevState => {
      if (name === 'selectedMotorista') prevState.selectedMotorista = value
      else if (name === 'selectedModelo') prevState.selectedModelo = value
      else if (name === 'selectedTransportadora') prevState.selectedTransportadora = value
      else if (name === 'selectedCarroceria') prevState.selectedCarroceria = value
      else if (name === 'selectedRodado') prevState.selectedRodado = value
      else prevState.veiculo[name] = value
      return { ...prevState }
    })
  }

  // Helpers
  const fetchInitInfo = veiculo => {
    setState(prevState => ({
      ...prevState,
      veiculo: veiculo ? veiculo : { ...INITIAL_STATE.veiculo },
      loadingMessage: LOAD_MESSAGE.INIT,
    }))
  }

  const resetModal = () => {
    setState({ ...INITIAL_STATE })
  }

  const buildInfo = veiculo => {
    setState(prevState => {
      if (veiculo.id) {
        const modelo = prevState.infoIniciais.manufacturers.find(
          m => m.id === veiculo.manufacturer_id,
        )
        if (!modelo) prevState.errorMessage = 'Modelo de Veículo NÃO localizado. Contate o suporte'

        const motorista = prevState.infoIniciais.drivers.find(
          d => d.id === veiculo.default_driver_id,
        )
        if (!motorista) prevState.errorMessage = 'Motorista NÃO encontrado. Contate o suporte'

        const transportadora = prevState.infoIniciais.transportadoras.find(
          t => t.id === veiculo.transportadora_id,
        )

        if (modelo && motorista) {
          prevState.selectedModelo = modelo
          prevState.selectedMotorista = motorista
          prevState.selectedTransportadora = transportadora
        }
        if (veiculo.tipo_rodado)
          prevState.selectedRodado = RODADOS.find(r => r.value === veiculo.tipo_rodado)
        if (veiculo.tipo_carroceria)
          prevState.selectedCarroceria = CARROCERIAS.find(c => c.value === veiculo.tipo_carroceria)
      }
      return { ...prevState, loadingMessage: LOAD_MESSAGE.NONE }
    })
  }

  //Hooks
  useEffect(() => {
    if (show) fetchInitInfo(data)
  }, [show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SAVE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        const formattedVeiculo = {
          ...state.veiculo,
          vehicle_badge:
            state.veiculo.vehicle_badge !== '___-____'
              ? state.veiculo.vehicle_badge.toUpperCase()
              : '',
          manufacturer_id: state.selectedModelo.id,
          default_driver_id: state.selectedMotorista.id,
          tp_id: selectedTp,
          capacity_m3: state.veiculo.capacity_m3 !== '' ? state.veiculo.capacity_m3 : null,
          tara_kg: state.veiculo.tara_kg !== '' ? state.veiculo.tara_kg : null,
          renavam: state.veiculo.renavam ? state.veiculo.renavam : null,
          uf_licenciamento: state.veiculo.uf_licenciamento
            ? state.veiculo.uf_licenciamento.toUpperCase()
            : null,
          year: state.veiculo.year !== '' ? state.veiculo.year : null,
          initial_km: state.veiculo.initial_km !== '' ? state.veiculo.initial_km : null,
          qtd_posicoes_carregamento:
            state.veiculo.qtd_posicoes_carregamento !== ''
              ? state.veiculo.qtd_posicoes_carregamento
              : null,
          max_distance_km:
            state.veiculo.max_distance_km !== '' ? state.veiculo.max_distance_km : null,
          transportadora_id: state.selectedTransportadora ? state.selectedTransportadora.id : null,
          tipo_rodado: state.selectedRodado ? state.selectedRodado.value : null,
          tipo_carroceria: state.selectedCarroceria ? state.selectedCarroceria.value : null,
        }
        saveVeiculo(formattedVeiculo)
        break

      case LOAD_MESSAGE.INIT:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        getVeiculoInfoIniciais(selectedTp)
        break

      case LOAD_MESSAGE.BUILD:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        buildInfo(state.veiculo)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        onModalSave(state.savedVeiculo)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      header="Veículo"
      isVisible={show}
      onClose={() => {
        resetModal()
        onModalClose()
      }}
      width={800}
    >
      <form className="p-grid">
        <div className="p-col-6">
          <InputText
            label="Nome Reduzido:*"
            value={state.veiculo.nickname}
            onChange={value => onFormContentChange('nickname', value.toUpperCase())}
          />
        </div>
        <div className="p-col-3">
          <InputPlacaVeiculo
            label="Placa:*"
            value={state.veiculo.vehicle_badge}
            onChange={value => onFormContentChange('vehicle_badge', value)}
          />
        </div>
        <div className="p-col-3">
          <InputNumeroInteiro
            label="Ano Fabricação:"
            value={state.veiculo.year}
            onChange={value => onFormContentChange('year', value)}
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            label="Modelo:*"
            value={state.selectedModelo}
            optionLabel="name"
            options={state.infoIniciais.manufacturers}
            filter={true}
            onChange={value => onFormContentChange('selectedModelo', value)}
          />
        </div>
        <div className="p-col-3">
          <InputNumeroInteiro
            marginTop={9}
            label="Capacidade (KG):*"
            value={state.veiculo.capacity_kg}
            onChange={value => onFormContentChange('capacity_kg', value)}
          />
        </div>
        <div className="p-col-3">
          <InputNumeroInteiro
            marginTop={9}
            label="Capacidade (M³):"
            value={state.veiculo.capacity_m3}
            onChange={value => onFormContentChange('capacity_m3', value)}
          />
        </div>
        <div className="p-col-6">
          <CustomDropdownWithFilter
            label="Motorista Padrão:*"
            value={state.selectedMotorista}
            optionLabel="name"
            options={state.infoIniciais.drivers}
            filter={true}
            onChange={value => onFormContentChange('selectedMotorista', value)}
          />
        </div>
        <div className="p-col-6">
          <InputNumeroInteiro
            marginTop={9}
            label="Quilometragem Inicial (Km):"
            value={state.veiculo.initial_km}
            onChange={value => onFormContentChange('initial_km', value)}
          />
        </div>
        <div
          className="p-col-6 flex"
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          <CustomRadioButton
            items={CATEGORIES}
            value={state.veiculo.category}
            onChange={value => onFormContentChange('category', value)}
          />
        </div>
        <div className="p-col-6">
          {state.veiculo.category === 'Spot' && (
            <CustomDropdown
              label="Transportadora:"
              value={state.selectedTransportadora}
              optionLabel="nome"
              options={state.infoIniciais.transportadoras}
              filter={true}
              onChange={value => onFormContentChange('selectedTransportadora', value)}
            />
          )}
        </div>
        <div className="p-col-6">
          <InputNumeroInteiro
            label="Qtd. Posições Pallet Carregamento:"
            value={state.veiculo.qtd_posicoes_carregamento}
            onChange={value => onFormContentChange('qtd_posicoes_carregamento', value)}
          />
        </div>
        <div className="p-col-6">
          <InputNumeroInteiro
            label="Distância Máxima (km):"
            value={state.veiculo.max_distance_km}
            onChange={value => onFormContentChange('max_distance_km', value)}
            allowNegative={false}
          />
        </div>
        <div className="p-col-6">
          <CustomCheckbox
            checked={state.veiculo.actived}
            onChange={value => onFormContentChange('actived', value)}
          >
            Ativo
          </CustomCheckbox>
        </div>

        {/* Seção de dados exigidos na emissão de MDFe */}
        <div className="p-col-12" style={{ marginTop: 20, marginBottom: 0 }}>
          <h4 style={{ marginBottom: 0 }}>Dados para MDFe</h4>
          <span style={{ fontSize: '0.8rem', color: '#888' }}>
            Os campos com * são obrigatórios para emitir MDFe com este veículo (não impedem salvar
            o cadastro). RENAVAM é opcional.
          </span>
        </div>
        <div className="p-col-3">
          <InputNumeroInteiro
            marginTop={9}
            label="Tara (KG):*"
            value={state.veiculo.tara_kg}
            onChange={value => onFormContentChange('tara_kg', value)}
            allowNegative={false}
          />
        </div>
        <div className="p-col-3">
          <InputText
            label="UF Licenciamento:*"
            marginTop={9}
            value={state.veiculo.uf_licenciamento || ''}
            onChange={value =>
              onFormContentChange(
                'uf_licenciamento',
                value
                  .toUpperCase()
                  .replace(/[^A-Z]/g, '')
                  .slice(0, 2),
              )
            }
          />
        </div>
        <div className="p-col-3">
          <CustomDropdown
            label="Tipo de Rodado:*"
            value={state.selectedRodado}
            optionLabel="label"
            options={RODADOS}
            filter={true}
            onChange={value => onFormContentChange('selectedRodado', value)}
          />
        </div>
        <div className="p-col-3">
          <CustomDropdown
            label="Tipo de Carroceria:*"
            value={state.selectedCarroceria}
            optionLabel="label"
            options={CARROCERIAS}
            filter={true}
            onChange={value => onFormContentChange('selectedCarroceria', value)}
          />
        </div>
        <div className="p-col-3">
          <InputText
            label="RENAVAM: (opcional)"
            marginTop={9}
            value={state.veiculo.renavam || ''}
            onChange={value => onFormContentChange('renavam', value.replace(/\D/g, '').slice(0, 11))}
          />
        </div>

        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(VeiculoModal)
